import useIdentity from "@/features/ui/hooks/use-identity";
import { useMemo } from "react";
import { DenseOrderSheet } from "@/features/order-sheets/order-sheet.type";
import { LightLineSheet } from "@/features/line-sheet-sets/line-sheet-set.types";
import BuyerOrderSheetSetPage from "@/features/order-sheet-sets/buyer-order-sheet-set-page";
import AgencyOrderSheetSetPage from "@/features/order-sheet-sets/agency-order-sheet-set-page";
import useOrderSheetSetPagePersistedQuery from "@/features/order-sheet-sets/hooks/use-order-sheet-set-page-persisted-query";

export function isDenseOrderSheet(
  value: DenseOrderSheet | LightLineSheet
): value is DenseOrderSheet {
  return (value as LightLineSheet).name === undefined;
}

export function isLineSheet(
  value: DenseOrderSheet | LightLineSheet
): value is LightLineSheet {
  return !isDenseOrderSheet(value);
}

function OrderSheetSetPage() {
  const identity = useIdentity();
  const company = useMemo(() => {
    return identity?.company;
  }, [identity]);

  const { value: query } = useOrderSheetSetPagePersistedQuery();

  if (company?.type === "BUYER" && !query.orderSheetId) {
    return <BuyerOrderSheetSetPage />;
  } else {
    return <AgencyOrderSheetSetPage />;
  }

}

// OrderSheetSetPage.whyDidYouRender = true;

export default OrderSheetSetPage;
